import type {
  IGetJobTasksByIdParams,
  IJobsApi,
  TDeleteJobsParams,
  TGetJobByIdParams,
  TGetJobsParams,
  TUpdateJobByIdParams,
  TUpdateJobByIdRequestBody
} from '@/types/api-types/jobs'
import type { TApiResponse } from '@/types/api-types/TApiResponse'
import { expandedProperties } from '@/utils/constants'
import BaseApiRequest from '../BaseApiRequest'
import JobsApiUrls from './endpoints'

class JobsApiRequest extends BaseApiRequest implements IJobsApi {
  async getJobs(params: TGetJobsParams): TApiResponse {
    return this.get(JobsApiUrls.JOBS(), params)
  }
  async getJobsTasks(params: TGetJobsParams): TApiResponse {
    return this.get(JobsApiUrls.JOBS_TASKS(), params)
  }
  async getJob(params: TGetJobByIdParams): TApiResponse {
    const { id, ...rest } = params
    return this.get(JobsApiUrls.JOB_BY_ID(id), rest)
  }
  async getJobTasks(params: IGetJobTasksByIdParams): TApiResponse {
    const { jobId, ...rest } = params
    return this.get(JobsApiUrls.JOB_TASKS_BY_ID(jobId), rest)
  }
  async updateJob(
    params: TUpdateJobByIdParams,
    requestBody: TUpdateJobByIdRequestBody
  ): TApiResponse {
    const { id, ...rest } = params
    const url = `${JobsApiUrls.JOB_BY_ID(id)}`
    return this.put(url, requestBody, { ...rest, ...expandedProperties })
  }
  async createJob(requestBody: TUpdateJobByIdRequestBody, params?: any): TApiResponse {
    return this.post(JobsApiUrls.JOBS(), requestBody, { ...params, ...expandedProperties })
  }
  async deleteJobs(params?: TDeleteJobsParams): TApiResponse {
    return this.delete(JobsApiUrls.JOBS(), params)
  }
  async getJobNotifications(params: TGetJobsParams): TApiResponse {
    return this.get(JobsApiUrls.JOBS_NOTIFICATIONS(), params)
  }
  async closeJob(params: TGetJobByIdParams): TApiResponse {
    const { id, ...rest } = params
    return this.post(JobsApiUrls.JOB_CLOSE(id), {}, rest)
  }
}

export default JobsApiRequest
